import { Filter } from '@cubejs-client/core';

import { GetOptionsQueryFunction } from '@/types/cube/query';
import { Period } from '@/types/date';
import { DateFormat } from '@/utils/date/format';
import { isPeriod } from '@/utils/date/isPeriod';

export const SUBNATIONAL_SALES_CUBE_NAME = 'subnational_sales';

const PERIOD_DIMENSION = `${SUBNATIONAL_SALES_CUBE_NAME}.period_date`;

const toPeriodFilter = ({ beginn, end }: Period): Filter => ({
  member: PERIOD_DIMENSION,
  operator: 'inDateRange',
  values: [beginn.format(DateFormat.dateFormatIso), end.format(DateFormat.dateFormatIso)],
});

/** Keeps the rows sold in any of the periods: a value sold in only one of them must stay selectable for the comparison. */
export const buildSubnationalSalesPeriodFilters = (periods: readonly (Period | undefined)[]): Filter[] => {
  const periodFilters = periods.filter(isPeriod).map(toPeriodFilter);
  return periodFilters.length ? [{ or: periodFilters }] : [];
};

/** Lists the values of a subnational_sales dimension sold within the Sales period range. */
export const buildSubnationalSalesOptionsQuery =
  (dimension: string, limit: number): GetOptionsQueryFunction =>
  ({ dateRange, comparisonPeriod }) => ({
    dimensions: [dimension],
    filters: buildSubnationalSalesPeriodFilters([dateRange, comparisonPeriod]),
    order: { [dimension]: 'asc' },
    limit,
  });
